export default "__VITE_ASSET__ehM50I8u__"